import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartCard from "./ChartCard";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top",
    },
  },
};

export default function BarChart({ dataToShow, title, sectionTitle, icon }) {
  let dataSets = [];
  Object.keys(dataToShow).map(function (data) {
    if (data !== "labels") {
      if (Array.isArray(dataToShow[data])) {
        dataSets = dataToShow[data];
      } else {
        dataSets.push(dataToShow[data]);
      }
    }
  });
  const data = {
    labels: dataToShow.labels,
    datasets: dataSets,
  };
  return (
    <ChartCard title={title}>
      <Bar
        data={data}
        options={options}
        style={{ height: "100%" }}

      />
    </ChartCard>
  );
}
